const regions = [
  { value: 'united_states', label: 'United States', path: '', key: 'US' },
  { value: 'canada', label: 'Canada', path: 'ca', key: 'CA' },
  { value: 'europe', label: 'Europe', path: 'eu', key: 'EU' },
];

module.exports = regions;
